import clsx from 'clsx';
import { Box } from '@alf/uikit';
import { USER_ROLES } from '@namespace/user';
import { INCREASED_ODDS } from '../../../../../constants';
import EventComments from '../../../../EventComments';
import EventFavoriteStar from '../../../../EventFavoriteStar';
import EventHead from '../../../../EventHead';
import { EventIcons } from '../../../../EventIcons';
import EventLinePosition from '../../../../EventLinePosition';
import EventParticipants from '../../../../EventParticipants';
import { IncreasedOddsIcon } from '../../../../IncreasedOddsIcon';
import LiveScore from '../../../../LiveScore';
import EventSubRowTable from './components/EventSubRowTable';
import MarketCount from './components/MarketCount';

import styles from './index.module.css';

export const EventBodyTable = ({
  lineView,
  eventId,
  lineKey,
  isLiveEvents,
  isDesktop,
  role,
  isShowStatUrl,
  classNames,
  increasedOdds,
  headGroups,
  isDisplayHeadMarkets
}) => (
  <Box direction="column">
    <Box
      flex="1 1 100%"
      className={clsx(styles.container, lineView && styles[lineView])}
      data-role={`event-body-${eventId}`}
    >
      <Box direction="column" flex="1 1 100%">
        <Box className={styles.participantsContainer}>
          {isDesktop && (
            <EventFavoriteStar
              eventId={eventId}
              className={styles.favorite}
              amplitudeEntryPoint="line"
            />
          )}
          <EventParticipants
            eventId={eventId}
            isActiveLink={true}
            isDisplayAdditionalData={true}
          />
          <LiveScore
            eventId={eventId}
            lineView={lineView}
            isShortVersion={true}
          />
        </Box>
        <Box
          className={styles.iconsContainer}
          left={isDesktop && role === USER_ROLES.USER ? 'l' : 's'}
          align="center"
        >
          <EventLinePosition eventId={eventId} lineView={lineView} />
          <EventHead
            lineView={lineView}
            isShowEventGroup={false}
            eventId={eventId}
          />
          <EventIcons
            eventId={eventId}
            isShowFavorite={!isDesktop}
            classNames={classNames}
            isShowStatUrl={isShowStatUrl}
            isHideUnselectedFavorite={true}
            isLiveEvents={isLiveEvents}
            amplitudeEntryPoint="line"
          />
          {isDesktop && (
            <EventComments
              eventId={eventId}
              classNames={{
                commentsContainerClass: styles.commentsContainer
              }}
            />
          )}
        </Box>
        {increasedOdds === INCREASED_ODDS.YES && (
          <IncreasedOddsIcon className={styles.increasedOddsIcon} />
        )}
      </Box>
      <Box className={styles.eventSubRowContainer}>
        <EventSubRowTable
          eventId={eventId}
          lineKey={lineKey}
          headGroups={headGroups}
          isDisplayHeadMarkets={isDisplayHeadMarkets}
          amplitudeEntryPoint="line"
        />
      </Box>
      <MarketCount eventId={eventId} lineView={lineView} />
    </Box>
    {!isDesktop && (
      <EventComments
        eventId={eventId}
        classNames={{
          commentsContainerClass: styles.commentsContainerBottom
        }}
      />
    )}
  </Box>
);
